const GATEWAY_PREFIX = 'gateway.'

export const inferAppUrlFromGateway = (gatewayUrl: string): string => {
  try {
    const { protocol, host } = new URL(gatewayUrl)
    if (!host.startsWith(GATEWAY_PREFIX)) return ''
    return `${protocol}//${host.slice(GATEWAY_PREFIX.length)}`
  } catch {
    return ''
  }
}

export const resolveAppUrl = (explicitUrl: string | undefined, gatewayUrl: string): string => {
  const url = explicitUrl || inferAppUrlFromGateway(gatewayUrl)
  return url.replace(/\/+$/, '')
}
